import { ToastErrorIcon } from '@avila-tek/ui/src';
import Link from 'next/link';
import React from 'react';
import Badge from '../Badge';

interface ErrorQRProps {
  title: string;
  subtitle: string;
}

function ErrorQR({ title, subtitle }: ErrorQRProps) {
  return (
    <div className="w-full flex flex-col justify-center items-center ">
      <ToastErrorIcon className="w-52 h-52" />
      <h2 className="text-2xl text-neutral-400 font-semibold my-5">{title}</h2>
      <span className="text-text-gray text-lg">{subtitle}</span>
      <Link href="/app/orders">
        <div className="text-purple-300 mt-1 font-semibold text-lg cursor-pointer">
          <Badge
            bgClassName="bg-purple-50"
            textClassName="text-purple-300"
            text="Ver ordenes"
          />
        </div>
      </Link>
    </div>
  );
}

export default ErrorQR;
